import React from 'react';
import { motion } from 'framer-motion';
import { Brain, Heart, Shield, Activity, DollarSign, Users } from 'lucide-react';
import { FeatureCard } from './FeatureCard';

const features = [
  {
    icon: Brain,
    title: 'Cognitive Enhancement',
    description: 'Track mental performance and learning progress with advanced analytics.'
  },
  {
    icon: Heart,
    title: 'Health Optimization',
    description: 'Monitor vital signs and health metrics in real-time with AI insights.'
  },
  {
    icon: Shield,
    title: 'Life Security',
    description: 'Protect and optimize your personal data with military-grade encryption.'
  },
  {
    icon: Activity,
    title: 'Fitness Tracking',
    description: 'Monitor your workouts and physical activities with precision.'
  },
  {
    icon: DollarSign,
    title: 'Financial Growth',
    description: 'Track and optimize your financial health and investments.'
  },
  {
    icon: Users,
    title: 'Social Connection',
    description: 'Build and maintain meaningful relationships with smart reminders.'
  }
];

export const FeaturesSection: React.FC = () => {
  return (
    <section className="py-24 relative">
      {/* Section Title */}
      <motion.div 
        className="text-center mb-16"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <h2 className="text-5xl font-bold mb-4">Unlock Your Full Potential</h2>
        <p className="text-xl text-gray-400">
          Track, analyze, and optimize every aspect of your life
        </p>
      </motion.div>

      {/* Features Grid */}
      <div className="grid grid-cols-3 gap-6">
        {features.map((feature, index) => (
          <FeatureCard
            key={feature.title}
            icon={feature.icon}
            title={feature.title}
            description={feature.description}
            delay={index * 0.1}
          />
        ))}
      </div>

      {/* Background Effects */}
      <motion.div
        className="absolute top-0 right-0 w-96 h-96 bg-neon-green/10 rounded-full blur-3xl"
        animate={{
          scale: [1, 1.2, 1],
          opacity: [0.3, 0.5, 0.3]
        }}
        transition={{
          duration: 4,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      />
      <motion.div
        className="absolute bottom-0 left-0 w-96 h-96 bg-neon-purple/10 rounded-full blur-3xl"
        animate={{
          scale: [1.2, 1, 1.2],
          opacity: [0.3, 0.5, 0.3]
        }}
        transition={{
          duration: 4,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      />
    </section>
  );
};